import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { cookieRef } from '@layouts/stores/config'
import { themeConfig } from '@themeConfig'
import { en, fr, ar, es } from 'vuetify/locale'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import flatpickr from 'flatpickr'

const messages = Object.fromEntries(
  Object.entries(import.meta.glob<{ default: any }>('./locales/*.json', { eager: true })).map(([key, value]) => {
    const localeCode = key.slice(10, -5)
    return [
      localeCode,
      {
        ...value.default,
        $vuetify: localeCode === 'en' ? en : localeCode === 'fr' ? fr : localeCode === 'ar' ? ar : localeCode === 'es' ? es : {},
      },
    ]
  })
)

const flatpickrLocales = {
  es: Spanish,
  en: flatpickr.l10ns.default,
}

let _i18n: any = null

export const getI18n = () => {
  if (_i18n === null) {
    _i18n = createI18n({
      legacy: false,
      locale: cookieRef('language', themeConfig.app.i18n.defaultLocale).value,
      fallbackLocale: 'en',
      messages,
    })

    // Set initial flatpickr locale
    const initialLocale = _i18n.global.locale.value
    const flatpickrLocale = flatpickrLocales[initialLocale as keyof typeof flatpickrLocales]
    if (flatpickrLocale) {
      flatpickr.localize(flatpickrLocale)
    }
  }

  return _i18n
}

function updateFlatpickrLocale(locale: string) {
  const flatpickrLocale = flatpickrLocales[locale as keyof typeof flatpickrLocales]

  if (flatpickrLocale) {
    flatpickr.localize(flatpickrLocale)
  }
}

export default function (app: App) {
  const i18n = getI18n()

  // Watch for locale changes and update flatpickr
  watch(
    () => i18n.global.locale.value,
    (newLocale) => {
      console.log('Locale changed to:', newLocale)
      updateFlatpickrLocale(newLocale)
    }
  )

  app.use(i18n)
}
